import { reactive, readonly } from 'vue';

interface ConfirmState {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  color: 'primary' | 'success' | 'error' | 'warning';
  resolver: ((ok: boolean) => void) | null;
}

const state = reactive<ConfirmState>({
  open: false,
  title: '',
  message: '',
  confirmLabel: 'Confirmar',
  cancelLabel: 'Cancelar',
  color: 'primary',
  resolver: null,
});

interface AskOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  color?: 'primary' | 'success' | 'error' | 'warning';
}

function ask(opts: AskOptions): Promise<boolean> {
  return new Promise((resolve) => {
    state.title = opts.title;
    state.message = opts.message;
    state.confirmLabel = opts.confirmLabel ?? 'Confirmar';
    state.cancelLabel = opts.cancelLabel ?? 'Cancelar';
    state.color = opts.color ?? 'primary';
    state.resolver = resolve;
    state.open = true;
  });
}

function resolve(ok: boolean): void {
  state.open = false;
  state.resolver?.(ok);
  state.resolver = null;
}

/** Composable de confirmação — diálogo reutilizável, sem `confirm()` nativo. */
export function useConfirm() {
  return {
    state: readonly(state),
    ask,
    resolve,
  };
}
